// Shared peer and assistant chat presentation; transports remain separate.
const { default: Styled } = require('styled-components');
const { default: IconButton } = require('@mui/material/IconButton');
const { default: ExpandLessIcon } = require('@mui/icons-material/ExpandLess');
const { default: TextField } = require('@mui/material/TextField');
const { transient$Props } = require('utils/styles');

exports.IconBackButton = Styled(IconButton)`
    position: absolute;
    left: 8px;
    z-index: 99;
`;

exports.IconCollapseButton = Styled(IconButton)`
    position: absolute;
    top: 9px;
    right: 8px;
    width: 40px;
    height: 34px;
`;

exports.HeaderExpandIcon = Styled(ExpandLessIcon, transient$Props)`
    transform: rotate(${({ $headerIsCollapsed }) => $headerIsCollapsed ? '-180deg' : '0deg'});
    position: absolute;
    top: 5px;
    right: 8px;
    transition: transform 0.25s ease-in-out;
`;

exports.HeaderTextWrapper = Styled.div`
    width: 100%;
    text-align: center;
    position: relative;
`;

exports.HeaderText = Styled.div`
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding-left: 15px;
    padding-right: 0;
`;

exports.HeaderTextAvatarLockup = Styled('div', transient$Props)`
    position: relative;
    font-weight: bold;
    width: calc(100% - 108px);
    left: 54px;
    line-height: 48px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    font-size: 1.25em;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
`;

exports.ChatInput = Styled(TextField)`
    font: inherit;
    width: 100%;
    min-height: 48px;
    padding-left: 15px;
    border: none;
    outline: none;
    resize: none;

    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

    ::before {
        display: none;
    }

    ::after {
        display: none;
    }
`;

exports.ChatWrapper = Styled.div`
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    min-height: 49px;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    left: 0;
    bottom: 0;
    background-color: white;
    border: 1px solid ${({ theme, $chatInputFocused }) => $chatInputFocused ? theme.palette.primary.main : 'rgba(18, 39, 79, 0.12)'};
    border-bottom: none;
    box-shadow: none;
    box-sizing: border-box;

    &,
    * {
        background-color: ${({ $isOffline }) => {

            return $isOffline ? '#fafad2' : 'white';
        }}
    }
`;
